import type { RouteRecordRaw } from 'vue-router';

export const routes: RouteRecordRaw[] = [
  {
    name: 'verify-invite',
    path: 'invite/verify',
    component: () => import('../VerifyIndex.vue'),
  },
];
